import React from 'react';
import { StyleSheet, View } from 'react-native';
import { DisplayText, theme, VStack } from '@sg/garnish';
import type {
  DeliveryOrderDetail,
  DeliveryOrderDetailInput,
  Product,
} from '@sg/graphql-schema';

import { UpsellProduct } from '../UpsellProduct';

// ─────────────────────────────────────────────────────────────────────────────

export const UpsellCategory = (props: UpsellCategoryProps) => {
  const {
    name,
    products,
    deliveryOrderDetail,
    upsellIdsBeingAdded,
    addUpsellToBag,
  } = props;

  return (
    <View style={styles.container}>
      <DisplayText sizeMatch={['24']}>{name}</DisplayText>

      <VStack gap={16}>
        {products.map((product) => (
          <UpsellProduct
            key={product.id}
            product={product}
            deliveryOrderDetail={deliveryOrderDetail}
            isAddingUpsell={upsellIdsBeingAdded.includes(product.id)}
            addUpsellToBag={addUpsellToBag}
          />
        ))}
      </VStack>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    gap: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type UpsellCategoryProps = {
  name: string;
  products: {
    id: string;
    name: string;
    cost: number;
    channelCost?: number;
    imageUrl: string;
    outOfStock: boolean;
    menuId: number;
  }[];
  deliveryOrderDetail?: DeliveryOrderDetail;
  upsellIdsBeingAdded: string[];
  addUpsellToBag: (payload: {
    product: Partial<Product>;
    deliveryDetails?: DeliveryOrderDetailInput;
  }) => void;
};
